class ProductWarranty extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('.product-warranty__checkbox');
    this.priceDisplay = this.querySelector('.product-warranty__price-amount');
    this.warrantyVariantId = this.checkbox?.dataset.warrantyVariantId;
    this.addingWarranty = false;
    this.warrantyPending = false;

    // Popup elements
    this.popupBtn = this.querySelector('[data-warranty-popup-btn]');
    this.popup = this.querySelector('[data-warranty-popup]');

    if (!this.checkbox) return;

    if (typeof subscribe === 'function') {
      subscribe('variant-change', this.onVariantChange.bind(this));
      subscribe('cart-update', this.onCartUpdate.bind(this));
    }

    // Intercept the Add to Cart button click to add warranty BEFORE main product.
    // This eliminates the race condition where the warranty is added after the
    // main product's cart drawer has already been rendered.
    this.initAddButtonInterceptor();

    // Intercept Buy It Now / dynamic checkout to create an independent
    // Storefront API cart with both main + warranty items.
    this.initBuyItNowInterceptor();

    // Initialize popup toggle behavior
    this.initPopup();
  }

  initPopup() {
    if (!this.popupBtn || !this.popup) return;

    const trigger = this.popupBtn.closest('.product-warranty__popup-trigger');
    if (!trigger) return;

    let closeTimer = null;

    const cancelClose = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };

    const closeWithDelay = () => {
      if (closeTimer) return;
      closeTimer = setTimeout(() => {
        this.popup.classList.remove('active');
        closeTimer = null;
        document.removeEventListener('mousemove', onMouseMove);
      }, 0);
    };

    // Check if the mouse event target is inside the popover area
    const isInsidePopover = (event) => {
      return trigger.contains(event.target) || this.popup.contains(event.target);
    };

    // Track mousemove while popup is open — checks both trigger and popup areas
    const onMouseMove = (event) => {
      if (isInsidePopover(event)) {
        cancelClose();
      } else if (this.popup.classList.contains('active')) {
        closeWithDelay();
      }
    };

    // Open popup when hovering the read-more button
    this.popupBtn.addEventListener('mouseenter', () => {
      cancelClose();
      this.openPopup();
      document.addEventListener('mousemove', onMouseMove);
    });

    // Close on Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.popup.classList.contains('active')) {
        this.closePopup();
        document.removeEventListener('mousemove', onMouseMove);
      }
    });

    // Click outside popup → close (needed for mobile)
    document.addEventListener('click', (event) => {
      if (!this.popup.classList.contains('active')) return;
      if (trigger.contains(event.target)) return;
      if (this.popup.contains(event.target)) return;
      this.closePopup();
      document.removeEventListener('mousemove', onMouseMove);
    });
  }

  openPopup() {
    this.popup.classList.add('active');
  }

  closePopup() {
    this.popup.classList.remove('active');
  }

  initAddButtonInterceptor() {
    // Note: <product-warranty> and <product-form> are siblings in the DOM,
    // so we must use document.querySelector rather than this.closest().
    const addButton = document.querySelector('product-form:not(.sticky-cart__form) [type="submit"][name="add"]');
    if (!addButton) return;

    const productForm = addButton.closest('product-form');
    if (!productForm) return;

    addButton.addEventListener('click', (event) => {
      if (!this.checkbox || !this.checkbox.checked) return;
      if (this.warrantyPending) return;

      event.preventDefault();
      event.stopPropagation();

      this.warrantyPending = true;
      this.addingWarranty = true;
      this.checkbox.disabled = true;

      const mainVariantId = document.querySelector('[name="id"]')?.value;
      if (!mainVariantId) {
        this.warrantyPending = false;
        this.addingWarranty = false;
        this.checkbox.disabled = false;
        return;
      }

      const qtyInput = document.querySelector('.quantity__input');
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      // Step 1: Add warranty to cart FIRST (use JSON endpoint to avoid FormData issues)
      console.log('=== WARRANTY ADD TO CART ===');
      console.log('warrantyVariantId:', this.warrantyVariantId);
      console.log('data-warranty-price:', this.checkbox.dataset.warrantyPrice);
      const warrantyPrice = parseInt(this.checkbox.dataset.warrantyPrice) || 1299;
      const requestBody = {
        id: this.warrantyVariantId,
        quantity: qty,
        properties: {
          _warranty_for: String(mainVariantId),
          _warranty_price: String(warrantyPrice),
          _warranty_sku: String(this.checkbox.dataset.warrantySku || '')
        }
      };
      console.log('requestBody:', JSON.stringify(requestBody));

      fetch(theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestBody)
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          console.log('Warranty add response:', data);
          if (data.status) {
          }
          // Step 2: Submit the main product form normally.
          // ProductForm.onSubmitHandler will add the main product via AJAX,
          // then render the cart drawer. Since warranty is already in the cart,
          // the rendered cart shows both items.
          const form = productForm.querySelector('form');
          if (form) {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        })
        .catch(e => {
          // If warranty fails, still allow main product to be added
          const form = productForm.querySelector('form');
          if (form) {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        });

      // Safety: ensure flags are reset if something goes wrong
      setTimeout(() => {
        if (this.warrantyPending) {
          this.warrantyPending = false;
          this.addingWarranty = false;
          this.checkbox.disabled = false;
        }
      }, 15000);
    });
  }

  initBuyItNowInterceptor() {
    const paymentButtonContainer = document.querySelector('[data-shopify="payment-button"]');
    if (!paymentButtonContainer) return;

    const storefrontUrl = `https://${window.location.hostname}/api/2026-07/graphql.json`;

    const handleClick = async (event) => {
      if (!this.checkbox || !this.checkbox.checked) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // Read fresh every click — DOM may not be ready at init time
      const storefrontToken = this.checkbox.dataset.storefrontToken;
      const warrantyVariantGid = this.checkbox.dataset.warrantyVariantGid;
      const mainVariantGid = this.checkbox.dataset.mainVariantGid;

      if (!mainVariantGid || !warrantyVariantGid || !storefrontToken) {
        return;
      }

      const qtyInput = document.querySelector('form[action*="/cart/add"] .quantity__input')
        || document.querySelector('.quantity__input');
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const warrantyPrice = parseInt(this.checkbox.dataset.warrantyPrice) || 1299;
      const mainVariantNumericId = mainVariantGid.split('/').pop();

      const query = `mutation cartCreate($input: CartInput!) {
        cartCreate(input: $input) {
          cart {
            id
            checkoutUrl
          }
          userErrors {
            field
            message
          }
        }
      }`;

      const variables = {
        input: {
          lines: [
            { merchandiseId: mainVariantGid, quantity: qty },
            {
              merchandiseId: warrantyVariantGid,
              quantity: qty,
              attributes: [
                { key: '_warranty_for', value: mainVariantNumericId },
                { key: '_warranty_price', value: String(warrantyPrice) },
                { key: '_warranty_sku', value: String(this.checkbox.dataset.warrantySku || '') }
              ]
            }
          ]
        }
      };

      try {
        const response = await fetch(storefrontUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontToken
          },
          body: JSON.stringify({ query, variables })
        });

        const result = await response.json();

        if (result.data?.cartCreate?.userErrors?.length > 0) {
          return;
        }

        const checkoutUrl = result.data?.cartCreate?.cart?.checkoutUrl;
        if (checkoutUrl) {
          window.location.href = checkoutUrl;
        }
      } catch (e) {
      }
    };

    // Attach in CAPTURE phase on the container — catches ALL buttons inside,
    // including "Buy with Shop", "More payment options", and any dynamically
    // rendered payment buttons (Shop Pay, PayPal, etc.).
    paymentButtonContainer.addEventListener('click', handleClick, true);
  }

  onVariantChange(data) {
    const variant = data?.data?.variant;
    if (!variant || !variant.price) return;

    const basePrice = variant.price;
    const warrantyPrice = ProductWarranty.getWarrantyPrice(basePrice);

    this.checkbox.dataset.basePrice = basePrice;
    this.checkbox.dataset.warrantyPrice = warrantyPrice;

    // Update main variant GID for Storefront API cartCreate
    if (variant.id) {
      this.checkbox.dataset.mainVariantGid = `gid://shopify/ProductVariant/${variant.id}`;
    }

    // Store SKU for warranty cart line property
    if (variant.sku) {
      this.checkbox.dataset.warrantySku = variant.sku;
    }

    if (this.priceDisplay) {
      this.priceDisplay.textContent = this.formatMoney(warrantyPrice);
    }
  }

  static getWarrantyPrice(basePriceCents) {
    if (basePriceCents >= 200000) return 19999;
    if (basePriceCents >= 150000) return 9999;
    if (basePriceCents >= 100000) return 7999;
    if (basePriceCents >= 70000) return 5999;
    if (basePriceCents >= 50000) return 3999;
    if (basePriceCents >= 40000) return 2999;
    if (basePriceCents >= 30000) return 2499;
    if (basePriceCents >= 20000) return 1999;
    if (basePriceCents >= 15000) return 1599;
    return 1299;
  }

  onCartUpdate() {
    // If warrantyPending is set, the click interceptor already added the
    // warranty before the main product form submitted. This cart-update event
    // is from the main product form's success handler. Reset flags.
    if (this.warrantyPending) {
      this.warrantyPending = false;
      this.addingWarranty = false;
      this.checkbox.disabled = false;
    }
    // No fallback — the click interceptor in initAddButtonInterceptor handles
    // all warranty adds. Cart-update events from deletions or other sources
    // should NOT trigger warranty re-adds.
  }

  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, theme.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }
}

customElements.define('product-warranty', ProductWarranty);
